import { Button, Text } from '@/ui';
import clsx from 'clsx';

import { FooterProps } from '.';

export function QuickLinks({ links, title }: Pick<FooterProps, 'links'> & { title?: string }) {
  return (
    <div className={clsx('flex flex-col gap-3', { 'items-center': !title })}>
      <Text element={'h3'} elementStyle="h4">
        {title}
      </Text>
      <ul
        className={clsx('flex max-w-(--breakpoint-sm) flex-col', {
          'items-center justify-center gap-x-3 sm:flex-row': !title,
        })}
      >
        {links?.map((link) => (
          <li key={link.url}>
            <Button size={'sm'} className={clsx({ 'px-0': title })} variant={'link'} href={link.url}>
              {link.label}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
